import { Section, TableOfContent } from '../../../typings/interfaces';
import { INDONESIAN } from '../../../assets/images';
// Indonesian
const IDSection: Section[] = [
  {
    name: '1: Referensi dan Gambaran Umum',
    subSections: [
      {
        name: 'Kata Pengantar',
        page: 3,
      },
      {
        name: 'Tujuan dan Penerapan Panduan Lapangan',
        page: 4,
      },
      {
        name: 'Definisi Kunci',
        page: 5,
      },
      {
        name: 'Hierarki Kontrol',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFEsaver',
    subSections: [
      {
        name: 'Kendaraan Bermotor – Keselamatan Lalu Lintas',
        page: 9,
      },
      {
        name: 'Bekerja di ketinggian',
        page: 12,
      },
      {
        name: 'Peralatan Bermotor Bergerak (MPE)',
        page: 18,
      },
      {
        name: 'Penguncian dan Pelabelan/Isolasi Energi',
        page: 22,
      },
      {
        name: 'Kerja Listrik',
        page: 25,
      },
      {
        name: 'Ruang Terkurung',
        page: 29,
      },
      {
        name: 'Material Curah & Penyimpanan',
        page: 32,
      },
      {
        name: 'Keselamatan Kereta Rel',
        page: 37,
      },
      {
        name: 'Pengerjaan Galian dan Parit',
        page: 40,
      },
      {
        name: 'Pengangkatan & Rigging',
        page: 45,
      },
      {
        name: 'Bahan Berbahaya',
        page: 49,
      },
      {
        name: 'Pekerjaan Panas',
        page: 52,
      },
    ],
  },
  {
    name: '3:  Sumber Informasi dan Alat Tambahan',
    subSections: [
      {
        name: `Bekerja di Atas dan Sekitar Air`,
        page: 56,
      },
      {
        name: 'Benda Jatuh atau Terjatuh',
        page: 59,
      },
      {
        name: 'Pengujian Atmosferis/Gas',
        page: 61,
      },
      {
        name: 'Komunikasi Bahaya Kimiawi',
        page: 65,
      },
    ],
  },
  {
    name: '4: Praktik Manajemen Keselamatan Cargill',
    subSections: [
      {
        name: 'Terminologi Kunci',
        page: 70,
      },
      {
        name: 'Penentuan Peristiwa Cedera Serius dan Kematian (SIF)',
        page: 72,
      },
      {
        name: 'Kategorisasi Potensi Cedera Serius dan Kematian (SIFp)',
        page: 73,
      },
      {
        name: 'Tabel Kriteria Penentuan Otomatis SIF',
        page: 74,
      },
      {
        name: 'Kinerja Manusia dan Organisasi (HOP)',
        page: 76,
      },
    ],
  },
];
const IDTableofContent: TableOfContent = {
  language: 'id',
  sections: IDSection,
  label: 'Daftar Isi',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (id_ID)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Panduan Saku HOP',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_id_ID.pdf',
  source: INDONESIAN,
};

export default IDTableofContent;
